module.exports = __webpack_public_path__ + "static/media/EANx.fb56038d.png";